export const fetchPersonData = async (id) => {
  const response = await fetch(`https://private.apifoot.com/api/1.0/en/search/${id}?targets[]=Team&targets[]=Competition&targets[]=Person&limit=30&groups[]=read_link&groups[]=_image&groups[]=_country`);  
  const data = await response.json();
  if (data[0] && data[0].object && data[0].object.slug) {
    const slug = data[0].object.slug;
    const peopleResponse = await fetch(`https://private.apifoot.com/api/1.0/en/people/with_club/?slug=${slug}&groups[]=read&groups[]=_image&groups[]=_club&groups[]=_meta`);
    const peopleData = await peopleResponse.json();
    return peopleData[0];
  }
  return null;
};

export const fetchTeamData = async (slug) => {
  try {
      console.log(`Fetching detailed team data for slug: ${slug}`);
      const teamResponse = await fetch(`https://private.apifoot.com/api/1.0/en/clubs/with_tournament/?slug=${slug}&groups[]=read&groups[]=_image&groups[]=_country`);
      
      if (!teamResponse.ok) {
        throw new Error(`HTTP error! status: ${teamResponse.status}`);
      }
      
      const teamData = await teamResponse.json();
      console.log("Detailed team data:", teamData);
      return teamData;
    
  } catch (error) {
    console.error("Error fetching team data:", error);
    return null;
  }
};

export const fetchSearchResults = async (query) => {
  const response = await fetch(
    "https://1r3p0ghdzwktqxu9p-1.a1.typesense.net/multi_search?x-typesense-api-key=ItfYDIz1mGDuZVXzvkYj0jYJ4avarL02",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        searches: [{
          query_by: "name, fm_id, search_terms",
          query_by_weights: "2,4,1",
          sort_by: "_text_match:desc,reputation:desc",
          highlight_full_fields: "name, fm_id, search_terms",
          collection: "detailed_game_items",
          q: query,
          page: 1,
          per_page: 20,
        }],
      }),
    }
  );
  const searchData = await response.json();
  return searchData;
};

export const fetchTeamMemberships = async (id) => {
  const response = await fetch(`https://private.apifoot.com/api/1.0/fr/memberships?person=${id}&pagination=0&groups[]=read&groups[]=_club&groups[]=_image&groups[]=_country`);
  const data = await response.json();
  return data;
};

